import { put, takeLatest } from "redux-saga/effects";
import {
  fetchCatalogDetailRequest,
  fetchCatalogDetailSuccess,
  fetchCatalogDetailFailure,
} from "./catalogSlice";
import baseURL from "../../utils/config";

function* fetchCatalogDetailSaga(action) {
  try {
    const { entryId } = action.payload;

    const response = yield fetch(`${baseURL}/api/cassandra/solutions_catalog_live/${entryId}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch catalog data: ${response.status}`);
    }

    const result = yield response.json();

    let data = result.success ? result.data : result;

    // If data has combinedData, parse it if it's a string, but preserve the full structure
    if (data && data.combinedData) {
      if (typeof data.combinedData === "string") {
        data.combinedData = JSON.parse(data.combinedData);
      }
      // Ensure entryId is set (use from response or fallback to URL parameter)
      if (!data.entryId) {
        data.entryId = entryId;
      }
      // Keep the full structure with entryId and combinedData
    } else if (data && !data.combinedData && !data.entryId) {
      // If the response is just the flat data object, wrap it in the expected structure
      data = {
        entryId: entryId,
        combinedData: data
      };
    }

    yield put(fetchCatalogDetailSuccess({ entryId: String(entryId), data }));
  } catch (error) {
    console.error("Error in fetchCatalogDetailSaga:", error);
    yield put(fetchCatalogDetailFailure(error.message));
  }
}

export function* watchCatalogSaga() {
  yield takeLatest(fetchCatalogDetailRequest, fetchCatalogDetailSaga);
}

